import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import { TemplatePreview } from './TemplatePreview';

export const TemplateSelector = ({ templates, selectedTemplate, setSelectedTemplate, setTemplatesOpen, templateVars, setTemplateVars  }) => {
    const handleSelect = (template) =>{
        setTemplatesOpen(false);        
        setSelectedTemplate((prev) => (prev?.name === template.name ? null : template));
    }

  return (
    <Box
        sx={{
            backgroundColor: '#111b21',
            padding: 3,
            borderRadius: 2,
            width: '100%',
        }}
    >
        <Grid container spacing={2} maxHeight={400} overflow="auto">
            {templates.map((tpl) => (
                <Grid size={{ xs:12, sm:6 }} key={tpl.name}>
                    <Box onClick={() => handleSelect(tpl)} sx={{ cursor: 'pointer' }}>
                        <TemplatePreview 
                            template={tpl} 
                            isSelected={selectedTemplate?.name === tpl.name} 
                            viewSelector={true} 
                            templateVars={templateVars}
                            setTemplateVars={setTemplateVars}
                        />
                    </Box>
                </Grid>
            ))}
        </Grid>
    </Box>
  );
};
